export default (_study, extraData) => extraData?.displaySets?.map((ds) => ds.SeriesDescription);
